module.exports = __webpack_public_path__ + "static/media/message-promotion-subtitle@3x.6adeca7f.png";